import CommentChip from './CommentChip';

export default CommentChip;
